"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spin = void 0;

var _core = require("@emotion/core");

var spinKeyframes = (0, _core.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n100% {\n  transform:rotate(360deg);\n}\n"])));

var spin = function spin() {
  return (0, _core.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation: ", " 2s linear infinite;\n"])), spinKeyframes);
};

exports.spin = spin;